export * from './l10n-provider.component';
